import { NgIf } from '@angular/common';
import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  forwardRef,
  input,
  model,
  signal,
  ViewChild,
} from '@angular/core';
import { Types } from 'shared-lib';
import { UploadService } from './upload.service';
import { v4 } from 'uuid';
import { Flowbite, InitFlowbiteFix } from '../../directive';
import { TextComponent } from '../text/text.component';
import { LoadingService } from '../loading/loading.service';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { EIcon } from '../../types';

@Component({
  selector: 'ui-upload',
  standalone: true,
  imports: [NgIf, forwardRef(() => TextComponent), ConfirmPopupComponent],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
})
@Flowbite()
export class UploadComponent implements AfterViewInit {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement> | undefined;

  placeHolder = model.required<string>();
  value = model<Types.TChoice | undefined>(undefined);
  required = input(false);
  editable = input(false);
  isTemplate = input(false);

  current = signal<Types.TChoice | undefined>(undefined);
  fileSize = signal(0);
  imageName = signal('');
  imagePreview = signal('');
  uploadProgress = signal(0);

  uiId = v4();
  uploadError: boolean = false;
  uploadSuccess: boolean = false;

  confirmPopup = false;
  EAlert = Types.EAlert;
  EIcon = EIcon;

  constructor(
    private uploadService: UploadService,
    private loadingService: LoadingService
  ) {
    effect(async () => {
      if (this.imagePreview()) {
        InitFlowbiteFix();
      }
      if (this.value()) {
        const response = await this.uploadService.readOne(this.value());
        if (!response) {
          return;
        }
        this.fileSize.set(Math.round(response.size / 1024));
        this.imagePreview.set(response.base64);
        this.imageName.set(response.originalname);
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.editable() && !this.value()) {
      this.value.set(undefined);
    }
  }

  // ZONA: isTemlpate

  onPlaceholderChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.placeHolder.set(inputValue as string);
  }

  // ZONA: is Edit

  onFileChange(event: any): void {
    const file = event.target.files[0] as File | null;
    this.uploadFile(file);
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    const file = event.dataTransfer?.files[0] as File | null;
    this.uploadFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  async uploadFile(file: File | null): Promise<void> {
    this.loadingService.start();
    const deleteResponse = await this.removeImage(true);
    if (deleteResponse === false) {
      this.loadingService.stop();
      return;
    }
    if (file && file.type.startsWith('image/')) {
      const response = await this.uploadService.uploadOne(file);
      if (typeof response == 'boolean') {
        this.uploadSuccess = false;
        this.uploadError = true;
        this.loadingService.stop();
        return;
      }
      this.loadingService.stop();
      this.value.set(response.id);
      this.fileSize.set(Math.round(response.size ?? 0 / 1024));
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview.set(e.target?.result as string);
      };
      reader.readAsDataURL(file);
      this.uploadSuccess = true;
      this.uploadError = false;
      this.imageName.set(file.name);
      this.loadingService.stop();
    } else {
      this.uploadSuccess = false;
      this.uploadError = true;
      this.loadingService.stop();
    }
  }

  async deleteClick() {
    this.loadingService.start();
    const response = await this.removeImage(false);
    if (response === false) {
      this.loadingService.stop();
      return;
    }
    this.loadingService.stop();
  }

  async removeImage(upload?: boolean) {
    this.confirmPopup = false;
    if (!this.value()) {
      return true;
    }
 

    if (upload) {
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
      return false;
    }

    const response = await this.uploadService.deleteOne(this.value());
    if (response) {
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
      this.value.set(undefined);
      this.imageName.set('');
      this.fileSize.set(0);
      this.imagePreview.set('');
      this.uploadSuccess = false;
      this.uploadError = false;
      this.uploadProgress.set(0);
      return true;
    }
    return false;
  }
}
